import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle, XCircle, Loader2, Mail } from 'lucide-react';
import { Button } from '@/components/ui/button';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [error, setError] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (token) {
      verifyEmail(token);
    } else {
      setStatus('error');
      setError('Kein Verifizierungstoken gefunden');
    }
  }, [searchParams]);

  const verifyEmail = async (token) => {
    try {
      await axios.get(`${BACKEND_URL}/api/auth/verify-email?token=${token}`);
      setStatus('success');
    } catch (err) {
      setStatus('error');
      setError(err.response?.data?.detail || 'Verifizierung fehlgeschlagen');
    }
  };

  return (
    <div className="min-h-screen bg-[#F6F8FB] flex items-center justify-center p-4" style={{ paddingTop: 'env(safe-area-inset-top)', paddingBottom: 'env(safe-area-inset-bottom)' }}>
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md bg-white rounded-2xl shadow-lg p-8 text-center"
      >
        {status === 'loading' && (
          <>
            <Loader2 className="w-16 h-16 text-teal-500 mx-auto mb-4 animate-spin" />
            <h1 className="font-display text-2xl font-bold text-slate-900 mb-2">
              E-Mail wird verifiziert...
            </h1>
            <p className="text-slate-500">
              Bitte warte einen Moment.
            </p>
          </>
        )}
        
        {status === 'success' && (
          <>
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <CheckCircle className="w-10 h-10 text-green-600" />
            </div>
            <h1 className="font-display text-2xl font-bold text-slate-900 mb-2">
              E-Mail verifiziert! ✅
            </h1>
            <p className="text-slate-500 mb-6">
              Deine E-Mail-Adresse wurde erfolgreich bestätigt.
            </p>
            <Button asChild className="w-full bg-teal-600 hover:bg-teal-700">
              <Link to="/login">Jetzt anmelden</Link>
            </Button>
          </>
        )}
        
        {status === 'error' && (
          <>
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <XCircle className="w-10 h-10 text-red-600" />
            </div>
            <h1 className="font-display text-2xl font-bold text-slate-900 mb-2">
              Verifizierung fehlgeschlagen
            </h1>
            <p className="text-slate-500 mb-6">
              {error}
            </p>
            <Button asChild variant="outline" className="w-full">
              <Link to="/login">Zurück zum Login</Link>
            </Button>
          </>
        )}
      </motion.div>
    </div>
  );
}
